import React from "react";

interface CalendarIconProps {
  width?: string;
  height?: string;
  color?: string;
  className?: string;
}

export const CalendarIcon: React.FC<CalendarIconProps> = ({
  width = "20",
  height = "20",
  color = "#000000",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="CalendarIcon">
        {/* Calendar outline */}
        <rect
          x="3"
          y="6"
          width="18"
          height="16"
          rx="2"
          stroke={color}
          strokeWidth="2"
          fill="none"
        />
        {/* Top binding lines */}
        <line
          x1="6"
          y1="4"
          x2="6"
          y2="6"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
        />
        <line
          x1="18"
          y1="4"
          x2="18"
          y2="6"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
        />
        {/* Horizontal line at 1/5 height */}
        <line x1="3" y1="9.2" x2="21" y2="9.2" stroke={color} strokeWidth="1" />
      </g>
    </svg>
  );
};
